import { zSchema } from "../../../schema-validation";

export const createCustomerAccountSchema = zSchema.object({
  business_name: zSchema.string(),
  zeal_id: zSchema.string(),
});
